import { Typography, Row, Col, Card, Button } from 'antd';
import { Chrome, Globe, Smartphone, Monitor } from 'lucide-react';

const { Title, Paragraph } = Typography;

const platforms = [
    {
        icon: <Chrome size={40} />,
        name: "Google Chrome",
        sub: "Extension for Desktop",
        link: "https://chromewebstore.google.com/detail/page-notes-pro/ekkbhlfdgnalobhgehklnlleecbhglil?authuser=0&hl=en",
        cta: "Add to Chrome",
        primary: true
    },
    {
        icon: <Globe size={40} />,
        name: "Mozilla Firefox",
        sub: "Add-on for Desktop",
        link: "https://addons.mozilla.org/en-US/firefox/addon/page-notes-live/",
        cta: "Get Add-on",
        disabled: false
    },
    {
        icon: <Monitor size={40} />,
        name: "Web Dashboard",
        sub: "Access Anywhere",
        link: "/notes",
        cta: "Open Dashboard",
        primary: true
    },
    {
        icon: <Smartphone size={40} />,
        name: "iOS App",
        sub: "iPhone & iPad",
        link: "#",
        cta: "Coming Soon",
        disabled: true
    },
    {
        icon: <Smartphone size={40} />,
        name: "Android App",
        sub: "Phones & Tablets",
        link: "#",
        cta: "Coming Soon",
        disabled: true
    }
];

export default function PlatformSection() {
    return (
        <div className="section platform-section" id="download">
            <div className="section-container">
                <div className="section-header">
                    <Title level={2}>Get the App</Title>
                    <Paragraph className="section-subtitle">
                        Available on all your favorite devices. Sync instantly.
                    </Paragraph>
                </div>

                <Row gutter={[24, 24]} justify="center" className="platform-grid">
                    {platforms.map((p, i) => (
                        <Col key={i} xs={24} sm={12} md={8} lg={4}>
                            <a
                                href={p.link}
                                target={p.link.startsWith('/') ? "_self" : "_blank"}
                                rel="noopener noreferrer"
                                style={{ display: 'block', height: '100%', cursor: p.disabled ? 'default' : 'pointer' }}
                                onClick={(e) => p.disabled && e.preventDefault()}
                            >
                                <Card className={`platform-card ${p.disabled ? 'disabled' : ''}`} bordered={false} hoverable={!p.disabled}>
                                    <div className="platform-icon">{p.icon}</div>
                                    <div className="platform-name">{p.name}</div>
                                    <div className="platform-sub">{p.sub}</div>
                                    <Button
                                        type={p.primary && !p.disabled ? "primary" : "default"}
                                        shape="round"
                                        className="platform-btn"
                                        disabled={p.disabled}
                                    >
                                        {p.cta}
                                    </Button>
                                </Card>
                            </a>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
}
